export default __webpack_public_path__ + "static/media/fd2.0e0f84fd.jpg";